/* Loaded only when the approved RUNSIBLE promotion is enabled in theme settings. */
(() => {
  const configElement = document.getElementById('ftl-gift-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const request = async (path, body) => {
    const response = await fetch(root + path, body === undefined
      ? {headers: {Accept: 'application/json'}}
      : {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    return result;
  };
  const isGift = item => item.properties?._ftl_gift === config.campaign;
  const showError = error => {
    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true, detail: {status: 'error', error: error.message || config.error}
    }));
    let notice = document.getElementById('ftl-gift-error');
    if (!notice) {
      notice = document.createElement('p');
      notice.id = 'ftl-gift-error';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'padding:12px;margin:12px;background:#fff3ed;color:#7b2419';
      const target = document.querySelector('#mini-cart .drawer__footer, .cart__recap, #main');
      target?.prepend(notice);
    }
    notice.textContent = error.message || config.error;
  };
  const synchronize = async () => {
    const end = config.endsAt === null ? Infinity : Date.parse(config.endsAt);
    // A null deadline matches the approved ongoing Thanksgiving server discount.
    if (Number.isNaN(end)) throw new Error(config.error);
    let cart = await request('cart.js');
    const active = config.active && Date.now() < end;
    if (!active) {
      for (const item of cart.items.filter(item => item.properties?.['Included gift'])) {
        const properties = {...item.properties};
        properties['Included gift'] = '';
        cart = await request('cart/change.js', {id: item.key, quantity: item.quantity, properties});
      }
    }
    const quantity = active ? cart.items.reduce((sum, item) =>
      sum + (config.products.includes(item.product_id) && !item.selling_plan_allocation ? item.quantity : 0), 0) : 0;
    const gifts = cart.items.filter(isGift);
    const updates = {};
    gifts.forEach((item, index) => {
      const expected = index === 0 ? quantity : 0;
      if (item.quantity !== expected) updates[item.key] = expected;
    });
    let changed = false;
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      changed = true;
    }
    if (quantity && !gifts.length) {
      await request('cart/add.js', {items: [{id: config.giftVariant, quantity,
        properties: {_ftl_gift: config.campaign, Gift: 'Included with WINDSIBLE'}}]});
      cart = await request('cart.js');
      changed = true;
    }
    const confirmedGifts = cart.items.filter(isGift);
    if (quantity && (confirmedGifts.reduce((sum, item) => sum + item.quantity, 0) !== quantity ||
        confirmedGifts.some(item => item.final_line_price !== 0))) {
      const remove = Object.fromEntries(confirmedGifts.map(item => [item.key, 0]));
      if (Object.keys(remove).length) await request('cart/update.js', {updates: remove});
      // Never silently charge for a promised gift when a discount is unavailable or incompatible.
      throw new Error(config.error);
    }
    if (active && quantity) {
      for (const item of cart.items.filter(item => item.properties?.['Included gift'])) {
        const properties = {...item.properties, 'Included gift': ''};
        cart = await request('cart/change.js', {id: item.key, quantity: item.quantity, properties});
        changed = true;
      }
    }
    if (changed) cart = await request('cart/update.js', {updates: {}, sections: ['mini-cart']});
    document.getElementById('ftl-gift-error')?.remove();
    if (window.FTLRunBundle) cart = await window.FTLRunBundle.sync();
    return cart;
  };
  const sync = () => {
    queue = queue.catch(() => {}).then(synchronize);
    return queue;
  };
  window.FTLGift = {sync, showError, refresh: () => request('cart/update.js', {updates: {}, sections: ['mini-cart']})};
  const confirmedForms = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (event.submitter?.name !== 'checkout' || confirmedForms.has(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    if (button.dataset.ftlChecking) return;
    button.dataset.ftlChecking = 'true';
    button.setAttribute('aria-busy', 'true');
    try {
      await sync();
      confirmedForms.add(form);
      form.requestSubmit(button);
    } catch (error) {
      showError(error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    } finally {
      delete button.dataset.ftlChecking;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
